import * as React from 'react';
import FormField, { BaseFormFieldProps } from './FormField';
import { NumberInputProps } from '../input/basicInputs';
import NumberInput from '../input/basicInputs/NumberInput';

class NumberInputFormField extends React.Component<BaseFormFieldProps & NumberInputProps> {
  render() {
    return <FormField {...this.props}>{({ input }) => <NumberInput {...input} />}</FormField>;
  }
}

export default NumberInputFormField;
